import {  FETCH_FEEDBACK_TYPES_SUCCESS } from '../types';

interface Action {
  type: string;
  payload?: any; 
}

export interface FeedbackType {
  FeedbackTypeID: number;
  Name: string;
  Description: string;
}

interface FeedbackState {
  isLoading: boolean;
  feedbackData: any;
  feedbackTypes: FeedbackType[];
  error: string | null;
}

const initialState: FeedbackState = {
  isLoading: false,
  feedbackData: null,
  feedbackTypes: [],
  error: null,
};


const feedbackReducer = (state: FeedbackState = initialState, action: Action): FeedbackState => {
  switch (action.type) {
      case FETCH_FEEDBACK_TYPES_SUCCESS:
        return { ...state, isLoading: false, feedbackTypes: action.payload };
    default:
      return state;
  }
};

export default feedbackReducer;
